<template>
  <div
    class="tb-dropdown"
    v-click-outside="() => (showDrop = false)"
    style="position: relative"
  >
    <div class="select3-selection">
      <div>
        <b-form-input
          class="input-selection"
          readonly="readonly"
          :disabled="disabled"
          placeholder="Select data"
          v-model="dataChoose[this.options.label]"
          @click="onOpenDropdown();getPosition()"
          :class="[showDrop ? classPosition ? 'border-dr-top' : 'border-dr-none': '' ]"
        />
  
          <img class="input-select3-drop" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=" alt="">
  <span class="input-select3-selection__clear"  v-show="!isBlank(dataChoose) && !disabled " @click="onHandlerClear" title="Remove all items">×</span>
      </div>
    </div> 
    <div class="m-dropdown" :class="{'m-dropdown-top' :classPosition}" v-show="showDrop">
      <span style="padding: 0.5rem; display: block">
        <div class="d-flex align-items-center">
        <b-form-input ref="searchForm"
        :class="`search-form-select3-${classSearch}`"
        type="search"
          autocomplete="off"
          @focus="$event.target.select()"
          v-model="searchQuery"
        />
        <feather-icon v-if="isReload" title="Reload" @click="loadData" icon="RefreshCcwIcon" class="mr-50 ml-50 cursor-pointer
        " />
          </div>
        <vue-perfect-scrollbar
          :settings="{
            maxScrollbarLength: 150,
            suppressScroll: true,
          }"
          style="max-height: 30vh"
          class="scrollable-container scroll-area"
        >
          <table
            class="m-table"
            style="
              border-collapse: collapse;
              width: 100%;
              margin-top: 5px; 
              border: 1px solid #ddd;
            "
          >
            <th v-for="(i, index) in options.fields" :key="index + i">
              <td>{{i.label}}</td>
            </th>
            <tr v-if="loading" ><div class="p-1 ">Loading...</div></tr>
             <tr v-else-if="data.length == 0" ><div class="p-1 ">No results found</div></tr>
            <tr  v-else v-for="(item, index) in data" :key="index" :class="{'active-selector': item[options.value] == (dataChoose[options.value] || value)}">
              <td v-for="(i, e) in options.fields" :key="e" @click="onClickChoose(item)">
                {{ item[i.field] }} 
              </td>
            </tr>
          </table>
        </vue-perfect-scrollbar>
      </span>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import useJwt from "@/auth/jwt/useJwt";

export default {
  directives: {
    ClickOutside,
  },
  props: {
    value: { type: String },
    disabled: { type: Boolean, default: false },
    isReload: { type: Boolean, default: false },
    options: {
      type: Object,
      default() {
        return {
          value: "id",
          label: "name",
          fields: [
            { field: "code", label: "Code" },
            { field: "name", label: "Name" },
          ],
        };
      },
    },
  },
  data() {
    return {
      showDrop: false,
      loading: false,
      data: [],
      searchQuery: "",
      dataChoose: "",
      classSearch: "",
      classPosition: false,
    };
  },
  watch: {
    searchQuery() {
      this.loadData();
    },
    async value(n, o) {
      var dataSearch = this.data?.find((o) => o[this.options.value] == n);
      if (!dataSearch) {
        await this.loadDataChoose(n);
        var dataChooseSearch = this.data.find(
          (o) => o[this.options.value] == n
        );

        this.dataChoose = dataChooseSearch || {};
      } else {
        this.dataChoose = dataSearch || {};
      }
    },
  },
  async mounted() {
    this.classSearch = this.makeid(10);
    if (this.value) {
      await this.loadDataChoose(this.value);
      var dataChooseSearch = this.data.find(
        (o) => o[this.options.value] == this.value
      );
      this.dataChoose = dataChooseSearch || {};
    } else {
      this.loadData();
    }
  },
  methods: {
    getPosition(e) {
      var evt = e ? e : window.event;
      var clickX = 0,
        clickY = 0;

      if (
        (evt.clientX || evt.clientY) &&
        document.body &&
        document.body.scrollLeft != null
      ) {
        clickX = evt.clientX + document.body.scrollLeft;
        clickY = evt.clientY + document.body.scrollTop;
      }
      if (
        (evt.clientX || evt.clientY) &&
        document.compatMode == "CSS1Compat" &&
        document.documentElement &&
        document.documentElement.scrollLeft != null
      ) {
        clickX = evt.clientX + document.documentElement.scrollLeft;
        clickY = evt.clientY + document.documentElement.scrollTop;
      }
      if (evt.pageX || evt.pageY) {
        clickX = evt.pageX;
        clickY = evt.pageY;
      }

      return (this.classPosition =
        window.innerHeight - evt.screenY > 200 ? false : true);
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    onOpenDropdown() {
      this.showDrop = !this.showDrop;
      if (this.showDrop == true) {
        this.$nextTick(() => {
          var searchQueryTB = document.getElementsByClassName(
            `search-form-select3-${this.classSearch}`
          )[0];
          searchQueryTB && searchQueryTB.focus();
        });
      }
      this.loadData();
    },
    onClickChoose(item) {
      this.$emit("input", item[this.options.value]);
      this.$emit("select", item);

      this.dataChoose = item;

      this.showDrop = false;
    },
    onHandlerClear() {
      this.$emit("input", "");
      this.$emit("select", {});

      this.searchQuery = "";
      this.dataChoose = "";
    },
    loadData() {
      this.loading = true;
      useJwt
        .get(this.options.url, {
          params: { search: this.searchQuery },
        })
        .then((response) => {
          this.data = response.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isBlank(value) {
      const isFalsy = (value) => !value;
      const isWhitespaceString = (value) =>
        typeof value === "string" && /^\s*$/.test(value);
      const isEmptyCollection = (value) =>
        (Array.isArray(value) || value === Object(value)) &&
        !Object.keys(value).length;

      if (isFalsy(value)) return true;
      if (isWhitespaceString(value)) return true;
      if (isEmptyCollection(value)) return true;

      return false;
    },
    async loadDataChoose(search) {
      this.loading = true;
      return useJwt
        .get(this.options.url, {
          params: { search: search },
        })
        .then((response) => {
          this.data = response.data.result;
          return this.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>


<style lang="scss">
.tb-dropdown {
  flex-shrink: 0;
  flex-grow: 1;
  .form-control[readonly] {
    background-color: #fff;
  }
  .form-control[disabled] {
    background-color: #efefef;
  }

  .m-table {
    th {
      text-align: center;
      border: 1px solid #ddd;
      background-color: #2b938c60 !important;

      td {
        display: block;

        padding: 6px;
      }
    }
    tr {
      td {
        text-align: left;
        padding: 5px;
        border: 1px solid #ddd;
      }
    }
    tr:hover {
      background-color: rgba(43, 147, 140, 0.12) !important;
      color: #6e6b7b !important;
    }
  }
  .m-dropdown {
    background-color: white;
    border-bottom: 1px solid #2b938c;
    border-left: 1px solid #2b938c;
    border-right: 1px solid #2b938c;
    border-radius: 0px 0px 4px 4px;
    position: absolute;
    width: 100%;
    z-index: 999;
  }
  .border-dr-none {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-color: #2b938c !important;
  }
  .border-dr-top {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: #2b938c !important;
  }
  .select3-selection {
    .input-selection {
      display: inline-block;
      position: relative;
      &::before {
        content: "";
      }
    }
  }
}
.active-selector {
  background-color: #2b938c !important;
  color: white !important;
}
.input-select3-drop {
  position: absolute;
  font-weight: bold;
  top: 39%;
  right: 14px;
  width: 14px;
}
.input-select3-selection__clear {
  position: absolute;
  font-weight: bold;
  line-height: 28px;
  top: 14.5%;
  cursor: pointer;
  right: 30px;
}
.is-invalid .input-selection {
  border-color: #ea5455 !important;
}

.m-dropdown-top {
  bottom: 38px !important;
  border-top: 1px solid #2b938c !important;
  border-bottom: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 0.357rem !important;
  border-top-right-radius: 0.357rem !important;
}
</style>